
(function(){
  var input = document.getElementById('umSearch');
  if(!input) return;
  var wrap = document.querySelector('.um-wrap');
  if(!wrap) return;
  var cards = wrap.querySelectorAll('.um-card');
  var sections = wrap.querySelectorAll('.um-section');
  var noresult = document.getElementById('umNoResult');
  function norm(s){ return (s || '').toLowerCase(); }
  function apply(){
    var q = norm(input.value).trim();
    var anyVisible = false;
    for(var i=0;i<cards.length;i++){
      var card = cards[i];
      var hay = norm(card.getAttribute('data-search') || '');
      var hit = !q || hay.indexOf(q) !== -1;
      card.style.display = hit ? '' : 'none';
      if(hit) anyVisible = true;
    }
    for(var j=0;j<sections.length;j++){
      var sec = sections[j];
      var visible = false;
      var sc = sec.querySelectorAll('.um-card');
      for(var k=0;k<sc.length;k++){ if(sc[k].style.display !== 'none'){ visible = true; break; } }
      sec.style.display = visible ? '' : 'none';
    }
    if(noresult){ noresult.style.display = anyVisible ? 'none' : 'block'; }
  }
  input.addEventListener('input', apply);
  input.addEventListener('search', apply);
})();
